import cn from 'classnames';
import { Counter } from 'components/counter';
import { COUNT_SYMBOL } from 'components/dynamic-bundle/constants';
import { FC, ReactNode } from 'react';

interface ProductPictureProps {
  amount: number;
  'aria-label'?: string;
  className?: string;
  children: ReactNode;
}

export const ProductPicture: FC<ProductPictureProps> = ({
  amount,
  'aria-label': ariaLabel,
  className,
  children,
}) => (
  <div className={cn('relative shrink-0', className)} data-test="product-picture">
    {children}
    <Counter value={amount + COUNT_SYMBOL} size="md" position="top-left" aria-label={ariaLabel} />
  </div>
);
